import $ from 'jquery';
import Glide from '@glidejs/glide';
import slick from 'slick-carousel';

//Sliders

$( () => {
  // NOT ON WINDOW LOAD DUE TO SHOWHOME BANDAID
  if( $( '.showhome-glide' ).length ) {
    let shGlide = document.querySelector( '.showhome-glide' )

    new Glide( shGlide, {
      type: 'slider',
      startAt: 0,
      perView: 2,
      bound: true,
      gap: 24,
      peek: {
        before: 0,
        after: 200
      },
      breakpoints: {
        767: {
          perView: 1,
          peek: {
            before: 0,
            after: 100
          },
        },
        420: {
          perView: 1,
          peek: {
            before: 0,
            after: 75
          },
        }
      }
    } ).mount()
  }


  if( $( '.slider-floorplans' ).length ){

    var sliderFloor = document.querySelectorAll( '.slider-floorplans' );
    var sliderButton = document.querySelectorAll( '.slider-button' );

    for ( var i = 0; i < sliderFloor.length; i++ ) {
    
      let floorTrack = new Glide( sliderFloor[i], {
        type: 'slider',
        animationDuration: 270,
        perTouch: 1,
        perView:1, 
        touchRatio: 1
      } ).mount()
    
    
      Array.from( sliderButton ).forEach( el => {
        el.addEventListener( 'click', ( e ) => {
          floorTrack.go( '='+(e.target.dataset.index ) );

          $(el).addClass('active').siblings('.slider-button').removeClass('active');
        })
      })
    }
  }
})

  if( $( '.slider-amen-info' ).length ){

    let sliderFloor = document.querySelectorAll( '.slider-amen-info' );
    let sliderButton = document.querySelectorAll( '.slider-button' );

    for ( let i = 0; i < sliderFloor.length; i++ ) {
    
      let floorTrack = new Glide( sliderFloor[i], {
        type: 'slider',
        animationDuration: 270,
        perTouch: 1,
        perView:1, 
        touchRatio: 1
      } ).mount()
    
    
      Array.from( sliderButton ).forEach( el => {
        el.addEventListener( 'click', ( e ) => {
          floorTrack.go( '='+(e.target.dataset.index ) );

          $(el).addClass('active').siblings('.slider-button').removeClass('active');
        })
      })
    }
  }

// makes a value convert from 400,000 to 400k or 1,600,000 to 1.6m
function numFormatter( num ) {
  return Math.abs( num ) > 999 && Math.abs( num ) < 1000000 ? Math.sign( num )*( ( Math.abs( num )/1000 ).toFixed( 1 ) ) + 'k' : Math.sign( num )*( ( Math.abs( num )/1000000 ).toFixed( 1 ) ) + 'mil'
}

function renderShowhomeGrid(){
  //check to see is there are no showhome cards available. If none, then display the set placeholder image
  $( '.js-builder' ).each( function() {
    let showhomes = $( this ).find( '.js-showhomeCard:not(.hidden)' );

    if( showhomes.length == 0 ){
      $( this ).find( '.js-fullWidth' ).show();
    } else {
      $( this ).find( '.js-fullWidth' ).hide();
    }
  })
}

function renderCriteria(){
  $( '.js-criteria' ).each( function() {
    let hiddenTagCount = $( this ).find( '.tag:not(.hidden)' );

    if( hiddenTagCount.length == 0 ){
      $( this ).closest( '.js-criteria' ).hide();
    } else {
      $( this ).closest( '.js-criteria' ).show();
    }
  })
}

// simple regex to replace to ','
function numberWithCommas( x ) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
           

// On document load
$( function() {

  if( $( '#myRange' ).length ) {
  // The slider
  let slider = document.getElementById( 'myRange' );
  // Slider output
  let output = document.getElementById( 'rangeOut' );
  //Range of slider high-low
  let $low = document.getElementById( 'rangeOutLower' );
  let $high = document.getElementById( 'rangeOutHigher' ); 
  // Min and Max of all showhomes. Automatic
  let $sliderLow = document.getElementById( 'sliderLow' );
  let $sliderHigh = document.getElementById( 'sliderHigh' );

  // Display the default slider value
   output.innerHTML = numberWithCommas(parseInt(slider.value)); 

   // Display the default slider value - 50000 for default range
   $low.innerHTML = numFormatter( parseInt(slider.value) - 50000 );

   // Display the default slider value + 50000 for default range
   $high.innerHTML = numFormatter( parseInt( slider.value ) + 50000 );

   $sliderLow.innerHTML = numFormatter( $(slider).attr('min') );
   $sliderHigh.innerHTML = numFormatter( $(slider).attr('max') ); 

    // Update the current slider value ( when you lift off slider )
    slider.onchange = sliderChanged;
  }
})

const sliderChanged = function() {
  // when you move the slider it will show all styles, and add active class to show all button
  $( 'a.pill' ).removeClass('style-toggle')
  $( 'a.pill[data-style="all"]' ).addClass( 'style-toggle' );

  $('.js-showhomeCard').removeClass('hidden')
  $('.js-builder').removeClass( 'hidden' ) 
  $('.js-fullWidth').hide()
  $('.js-criteria').show()

  // Removes inactive class on slider
  $( '.showing' ).removeClass( 'inactive' );
  $( '#myRange' ).removeClass( 'inactive' );
  $( '.price-out' ).removeClass( 'inactive' );
  

  // slider
  let slider = document.getElementById( 'myRange' );

  // slider output
  let output = document.getElementById( 'rangeOut' );

  //slider output range
  let $low = document.getElementById( 'rangeOutLower' );
  let $high = document.getElementById( 'rangeOutHigher' );

  // Display the default slider value
  output.innerHTML = numberWithCommas(parseInt(slider.value));

  const $sliderInput = parseInt( slider.value )
  let low = 1;
  let high = 999999999999;

  // if a value is less than an amount subtract a certain amount, then adjust with the numFormatter
  // create ranges for annalytics. Right now theres a ceiling of 1,610,000.
  if( $low.innerHTML =  $sliderInput < 410000 ){
    low = $sliderInput - 25000;

  } else if( $low.innerHTML =  $sliderInput < 610000){
    low = $sliderInput - 50000;

  } else if( $low.innerHTML =  $sliderInput < 810000){
    low = $sliderInput - 75000;

  } else if( $low.innerHTML =  $sliderInput < 1010000 ){
    low = $sliderInput - 100000;

  } else if( $low.innerHTML =  $sliderInput < 1610000 ){
    low = $sliderInput - 150000;
  };

  if( $high.innerHTML =  $sliderInput < 410000 ){
    high = $sliderInput + 25000;

  } else if( $high.innerHTML =  $sliderInput < 610000){
    high = $sliderInput + 50000;

  } else if( $high.innerHTML =  $sliderInput < 810000){
    high = $sliderInput + 75000;

  } else if( $high.innerHTML =  $sliderInput < 1010000 ){
    high = $sliderInput + 100000;

  } else if( $high.innerHTML =  $sliderInput < 1610000 ){
    high = $sliderInput + 150000;
  };

  $low.innerHTML = numFormatter( low );
  $high.innerHTML = numFormatter( high );


  // filter with the price slider
  $( '.js-showhomeCard' ).each( function() {
    let price = $( this ).data( 'price' )

    if( price >= low && price <= high ){
      $( this ).removeClass('hidden order-last');
    } else {
      $( this ).addClass('hidden order-last');
    }
  })
  
  // filter by build type
  $( '.js-builder , .home-portfolio' ).each( function() {
    const inRange = low <= $( this ).data( 'build-high' ) && high >= $( this ).data( 'build-low' );
    if( inRange ){
      $( this ).removeClass('hidden');
    } else {
      $( this ).addClass('hidden');
    }
  })

  // push slider value to the data layer (need to create value trigger in analytics)
  window.dataLayer = window.dataLayer || [];
  dataLayer.push( {'event': 'price_input', 'value': $sliderInput} );

  //render that bad boy
  renderShowhomeGrid();
}

// a simple accordion
if( $( '.showmore' ).length ) {
  // filter by showhome style
  $( '.showmore a' ).on( 'click', function(e) {
    e.preventDefault();

    let $this = $( this );
    let style = $this.data( 'style' );

    $this.parent().children().removeClass('style-toggle');
    $this.addClass('style-toggle');

    $('.js-showhomeCard').removeClass('hidden')
    $('.js-builder').removeClass( 'hidden' )
    $('.js-fullWidth').hide()
    $('.js-criteria').show()

    // Adds inactive class to slider
    $( '.showing' ).addClass( 'inactive' );
    $( '#myRange' ).addClass( 'inactive' );
    $( '.price-out' ).addClass( 'inactive' );

    if( $( this ).data( 'style' ) == 'all' ){
      $( '.js-criteria' ).hide();
    }

    function filterStyles( className ){
      $( className ).each( function () {
        if( $( this ).data( 'style' ) == style || style == 'all' ){
          $( this ).removeClass('hidden order-last');
        } else {
          $( this ).addClass('hidden order-last');
        }  
      })
    }

    function filterStylesInvert( className ) {
      $( className ).each( function () {
        if( $( this ).data( 'style' ) == style || style == 'all' ){
          $( this ).addClass('hidden order-last');
        } else {
          $( this ).removeClass('hidden order-last');
          if( ! $( this ).closest('.js-builder').hasClass(style)){
            $( this ).closest('.js-builder').addClass( 'hidden' );
          }
        }  
      })
    }

    filterStyles( '.js-showhomeCard, .home-portfolio' );
    filterStylesInvert('.tag');
    renderCriteria();
    renderShowhomeGrid();
  })
}

$(document).on('click', '.js-button', () => {
  $('.showhome-card-base').removeClass('hidden');
  $('.js-button').hide();
});

// slick
let $slickElement = $('[data-slick]');

// nav slider left
$('.slick-prev').on( 'click' ,function(e) {
  e.preventDefault();
  $slickElement.slick('slickPrev');
});

// nav slider right
$('.slick-next').on( 'click' ,function(e) {
  e.preventDefault();
  $slickElement.slick('slickNext');
});

$($slickElement).on('init', function(event, slick){
  setTimeout( () => {
    let section = window.location.hash;
    if( section ) {
      $('html, body').animate({
        scrollTop: $( section ).offset().top
      }, 500);
    }
  }, 500 ) 
});

// init slick
$slickElement.slick({
  arrows: false,
  swipeToSlide: true,
  fade: true,
  rows: 0
});